export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-tumblr-fa788e6c28c753caa6a4eafcbf656523.svg";